<script>
import * as d3 from 'd3'

import LineChart from '@/components/plots/LineChart'

export default {
  computed: {
    curve_type() { return d3.curveNatural }
  },
  extends: LineChart,
  name: 'candela-line-chart-spline'
}
</script>
